"use client";

import styles from "@/styles/home/recommend-list.module.scss";
import { useState, useEffect } from "react";
import ProductItem from "@/components/global/ProductItem";
import productApi from '@/service/modules/productApi'
import { ProductType } from '@/types/product';


interface RecommendListProps {
  productId: string | number;
}
export default function ProductRecommendList({ productId }: RecommendListProps) {
  const [productList, setProductList] = useState<ProductType[]>([])

  useEffect(() => {
    getSimilar()
  }, []);

  const getSimilar = async () => {
    try {
      const res = await productApi.getSimilar(productId)

      if (res.data && res.data.pageList && res.data.pageList.items.length) { 
        setProductList(res.data.pageList.items as ProductType[])
      }
    } catch (error: any) {
      console.error(error)
    }
  }

  return (
    <div className={styles["comp-recommend-list"]}>

      <div className={styles["recommend-title"]}>
        You Might Also Like
      </div>

      {
        productList.length > 0 && (
          <div className={styles["recommend-list"]}>
            {productList.map((product: ProductType) => (
              <div className={styles["recommend-item"]} key={product.productID}>
                <ProductItem product={product} />
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}
